import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/notaNacional/';

class NotaFiscalNacionalService {
	constructor() {
		LoginService.currentUser.subscribe(data => {
			this.headers = {
				'Content-Type': 'application/json',
				'authorization': 'Bearer ' + (data ? data.token : '')
			};
		});
	}

	findAllNotas(idCliente, dataEmissaoIni, dataEmissaoFin, chave, numeroNfse, documentoPrestador, situacao, ambiente) {
		return axios.get(API_URL + 'allNotas?idCliente=' + idCliente + '&dataEmissaoIni=' + dataEmissaoIni + '&dataEmissaoFin=' + dataEmissaoFin + '&chave=' + chave + '&numeroNfse=' + numeroNfse + '&documentoPrestador=' + documentoPrestador + '&situacao=' + situacao + '&ambiente=' + ambiente, { headers: this.headers }).then(response => (this.data = response.data));
	}

	reprocessarGeral(idCliente, dataEmissaoIni, dataEmissaoFin, chave, numeroNfse, documentoPrestador, ambiente) {
		return axios.post(API_URL + 'reprocessarGeral?idCliente=' + idCliente + '&dataEmissaoIni=' + dataEmissaoIni + '&dataEmissaoFin=' + dataEmissaoFin + '&chave=' + chave + '&numeroNfse=' + numeroNfse + '&documentoPrestador=' + documentoPrestador + '&ambiente=' + ambiente, null, { headers: this.headers }).then(response => (this.data = response.data));
	}

	reprocessar(id, ambiente) {
		return axios.post(API_URL + 'reprocessar?id=' + id + '&ambiente=' + ambiente, null, { headers: this.headers }).then(response => (this.data = response.data));
	}

	transmitirDps(idCliente, idDps) {
		return axios.post(API_URL + 'transmitirDps?idCliente=' + idCliente + '&idDps=' + idDps, null, { headers: this.headers }).then(response => (this.data = response.data));
	}

	findAllNotasParaConversaoDaps(idCliente, idContribuinte, ano, mes, documentoTomador) {
		return axios.get(API_URL + 'allNotasParaConversaoDaps?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes + '&documentoTomador=' + documentoTomador, { headers: this.headers }).then(response => (this.data = response.data));
	}

	importarNotaNacionalDaps(idCliente, idUsuario, idContribuinte, notasNacionais) {
		return axios.post(API_URL + 'importarNotaNacionalDaps?idCliente=' + idCliente + '&idUsuario=' + idUsuario + '&idContribuinte=' + idContribuinte, JSON.stringify(notasNacionais),
			{ headers: this.headers });
	}

	findAllDpsByFiltro(idCliente, idContribuinte, filtroNumero, filtroSituacao, filtroTipo, dataFatoGeradorIni, dataFatoGeradorFim, tipoAmbiente) {
		return axios.get(API_URL + 'filterDps?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&filtroNumero=' + filtroNumero + '&filtroSituacao=' + filtroSituacao + '&filtroTipo=' + filtroTipo + '&dataFatoGeradorIni=' + dataFatoGeradorIni + '&dataFatoGeradorFim=' + dataFatoGeradorFim + '&tipoAmbiente=' + tipoAmbiente, { headers: this.headers });
	}

	obterNotaByDps(dpsId) {
		return axios.get(API_URL + 'obterNotaByDps?dpsId=' + dpsId,
			{ headers: this.headers });
	}

	obterDadosDps(idCliente, dpsId) {
		return axios.get(API_URL + 'obterDadosDps?idCliente=' + idCliente + '&dpsId=' + dpsId,
			{ headers: this.headers });
	}

	simularCalculoIbsCbs(data) {
		return axios.post(API_URL + 'simularCalculoIbsCbs', JSON.stringify(data), { headers: this.headers }).then(response => response.data);
	}

	obterModoPrestacao() {
		return axios.get(API_URL + 'obterModoPrestacao', { headers: this.headers });
	}

	obterVinculoPrestacao() {
		return axios.get(API_URL + 'obterVinculoPrestacao', { headers: this.headers });
	}

	obterMecanismoApoioPrestador() {
		return axios.get(API_URL + 'obterMecanismoApoioPrestador', { headers: this.headers });
	}

	obterMecanismoApoioTomador() {
		return axios.get(API_URL + 'obterMecanismoApoioTomador', { headers: this.headers });
	}

	obterMovimentacaoTemporariaBens() {
		return axios.get(API_URL + 'obterMovimentacaoTemporariaBens', { headers: this.headers });
	}

	obterIndicadorEnvioMdic() {
		return axios.get(API_URL + 'obterIndicadorEnvioMdic', { headers: this.headers });
	}

}
export default new NotaFiscalNacionalService();